import { FORM_ACTIONS } from './formValidation'
import { get } from '@bigyouth/base'
import axios from 'axios'
import { get as getPipe } from '../utils/sigpipe'
import getOffset from '../utils/getOffset'
import slugify from 'slugify'

export default {
  name: 'contact',

  ui: {
    'types[]': '[js-contact-type]',
    company: '[js-contact-company]',
  },

  events: [
    {
      on: 'change',
      target: 'types',
      handle (e) {
        const input = this.ui.company.querySelector('input')
        if (e.target.value === config.trads['contact.pro']) {
          this.ui.company.classList.remove('hidden')
          input.setAttribute('required', true)
        } else {
          this.ui.company.classList.add('hidden')
          input.removeAttribute('required')
          input.value = null
        }
      },
    },
  ],

  componentDidMount () {
    const formId = this.el.getAttribute('data-form-id')

    if (formId) {
      this.pipe = getPipe(formId)

      if (this.pipe) {
        this.pipe.on(({ action, formData }) => {
          const formDataNew = new FormData()

          let subject = ''

          for (const [key, value] of Object.entries(formData)) {
            formDataNew.append(key, value)

            if (key === 'reason') {
              subject = value.split('//')[0]
            }
          }

          switch (action) {
            case FORM_ACTIONS.SUBMIT: {
              if (get('[js-contact-error]')) {
                get('[js-contact-error]').remove()
              }

              const url = config.locale === 'fr' ? '/ajax/contact' : '/en/ajax/contact'

              axios.post(url, formDataNew, {})
                .then(response => {
                  if (response.data.success) {
                    const successMessage = document.createElement('p')
                    successMessage.className = 'form__mandatory text-grass-green'
                    successMessage.innerHTML = config.trads['contact.success']
                    this.el.parentNode.append(successMessage)

                    window.scrollTo({
                      top: getOffset(get('#contact-form')),
                      left: 0,
                    })

                    this.el.remove()

                    if (typeof _paq !== 'undefined') {
                      _paq.push(['trackEvent', 'contact', 'formulaire', `filtre-form-ok-${slugify(subject)}`])
                    }
                  }
                })
                .catch(e => {
                  if (e.response) {
                    const error = document.createElement('div')
                    error.classList.add('form__error', 'text-right', '-mb-8')
                    error.setAttribute('js-contact-error', '')
                    error.innerHTML = `Erreur : ${e.response.data.message}`

                    this.el.append(error)

                    if (typeof _paq !== 'undefined') {
                      _paq.push(['trackEvent', 'contact', 'formulaire', 'formulaire-nook'])
                    }
                  }
                })
            }
          }
        })
      }
    }
  },
}
